module.exports = __webpack_public_path__ + "static/media/JoinImage.46b8eaa4.png";